import { render, staticRenderFns } from "./resourceVehicle.vue?vue&type=template&id=10a01840&scoped=true&"
import script from "./resourceVehicle.vue?vue&type=script&lang=js&"
export * from "./resourceVehicle.vue?vue&type=script&lang=js&"
import style0 from "./resourceVehicle.vue?vue&type=style&index=0&id=10a01840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a01840",
  null
  
)

export default component.exports